import React from 'react';
import Header from '@shared/header/header.container';
import Title from '../../shared/title/title';
import MerchantComponents from './merchant.components';
import MerchantButton from './merchant-button/merchant-button';
import GoBack from '../../shared/go-back/go-back.container';

interface MerchantsContentProps {
  selectPartner: () => void;
  selectDealer: () => void;
}

const { Container, ButtonsContainer } = MerchantComponents;

const MerchantsContent: React.FunctionComponent<MerchantsContentProps> = ({
  selectPartner,
  selectDealer
}) => {
  return (
    <>
      <Header type="support" />
      <GoBack />
      <Container>
        <Title text="intermediaryPages.merchants.title" />
        <ButtonsContainer>
          <MerchantButton
            text="intermediaryPages.merchants.buttons.dealer"
            handleOnClick={selectDealer}
          />
          <MerchantButton
            text="intermediaryPages.merchants.buttons.partner"
            handleOnClick={selectPartner}
          />
        </ButtonsContainer>
      </Container>
    </>
  );
};

export default MerchantsContent;
